import axios from 'axios';

const API_BASE_URL = 'https://live.ohyesworld.com';

export const getAllPackages = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/membership-plans/web-content`);
    return response.data;
  } catch (error) {
    console.error('Error fetching packages:', error);
    throw error;
  }
};

export const getPackageDetail = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/membership-plan/web-content`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching package detail for ID ${id}:`, error);
    throw error;
  }
};

export const submitPackageEnquiry = async (formData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/membership-plans/website/add-enquiry`,
      formData,
      { headers: { 'Content-Type': 'application/json' } }
    );
    console.log('response.data', response.data);
    return response.data;
  } catch (error) {
    console.error('Error submitting package enquiry:', error);
    throw error;
  }
};

export const getPaymentForigner = async (id) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/membership-plans/${id}/payment/forigner`,
      { currency: 'INR' },
      { headers: { 'Content-Type': 'application/json' } }
    );
    console.log('Payment response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching payment info:', error);
    throw error;
  }
};
